<app-navbar-style-two></app-navbar-style-two>

<div class="loading-spinner" *ngIf="loading">
    <div class="spinner"></div>
</div>

<div class="error-message" *ngIf="error">
    <h2>Oops! Something went wrong.</h2>
    <p>We couldn't load the industry information. Please try again later.</p>
</div>

<ng-container *ngIf="industryData && !loading && !error">
    <!-- Banner Section -->
    <div class="inner-banner">
        <div class="container">
            <div class="inner-title text-center">
                <h3>{{industryData.banner.heading}}</h3>
                <ul class="inner-list">
                    <li><i class='bx bx-building'></i> {{industryData.title}}</li>
                    <li><i class='bx bx-info-circle'></i> Industry Solutions</li>
                </ul>
            </div>
        </div>

        <div class="inner-banner-shape">
            <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Shape"></div>
            <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Shape"></div>
            <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Shape"></div>
            <div class="inner-banner-dots-2"><img src="assets/img/shape/dots-shape.png" alt="Shape"></div>
        </div>
    </div>

    <div class="industry-details-area pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="industry-article">
                        <div class="industry-article-img">
                            <img [src]="industryData.banner.backgroundImage" [alt]="industryData.title">
                        </div>

                        <div class="article-content">
                            <h2>{{industryData.overview.title}}</h2>
                            <div class="content-text">
                                <div [innerHTML]="industryData.overview.description"></div>
                            </div>
                        </div>

                        <!-- Key Features Section -->
                        <div class="features-content">
                            <h2>Key Features</h2>
                            <div class="row">
                                <div class="col-lg-6 col-md-6" *ngFor="let feature of industryData.overview.keyFeatures">
                                    <div class="single-features">
                                        <i [class]="feature.icon"></i>
                                        <h3>{{feature.title}}</h3>
                                        <p>{{feature.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Benefits Section -->
                        <div class="benefits-content">
                            <h2>Industry Benefits</h2>
                            <div class="row">
                                <div class="col-lg-6 col-md-6" *ngFor="let benefit of industryData.benefits">
                                    <div class="single-benefits">
                                        <i [class]="benefit.icon"></i>
                                        <h3>{{benefit.title}}</h3>
                                        <p>{{benefit.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Statistics Section -->
                        <div class="statistics-content">
                            <h2>Industry Statistics</h2>
                            <div class="row">
                                <div class="col-lg-4 col-md-6" *ngFor="let stat of industryData.statistics">
                                    <div class="single-counter">
                                        <i [class]="stat.icon"></i>
                                        <h2>{{stat.number}}</h2>
                                        <p>{{stat.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Testimonials -->
                        <div class="testimonials-content">
                            <h2>Client Success Stories</h2>
                            <div class="row">
                                <div class="col-lg-12" *ngFor="let testimonial of industryData.testimonials">
                                    <blockquote class="blockquote">
                                        <p>{{testimonial.quote}}</p>
                                        <span>{{testimonial.name}} - {{testimonial.organization}}</span>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="industry-widget-right">
                        <!-- Quick Contact -->
                        <div class="industry-widget">
                            <h3 class="title">Get Started</h3>
                            <div class="cta-content">
                                <h4>{{industryData.callToAction.title}}</h4>
                                <p>{{industryData.callToAction.description}}</p>
                                <a [routerLink]="industryData.callToAction.buttonLink" class="default-btn">
                                    {{industryData.callToAction.buttonText}}
                                    <i class='bx bx-right-arrow-alt'></i>
                                </a>
                            </div>
                        </div>

                        <!-- Features List -->
                        <div class="industry-widget">
                            <h3 class="title">Key Solutions</h3>
                            <div class="widget_categories">
                                <ul>
                                    <li *ngFor="let feature of industryData.features.list">
                                        <a href="javascript:void(0)">
                                            {{feature.title}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<app-footer-style-two></app-footer-style-two> 